import { render, staticRenderFns } from "./error_503.vue?vue&type=template&id=6038f454&"
import script from "./error_503.vue?vue&type=script&lang=js&"
export * from "./error_503.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports